module.exports = __webpack_public_path__ + "img/nodejsLogo.85458a67.png";